import type {
  NotificationsQueryKey,
  NotificationsQuerySuffix,
} from "./notifications.type";

import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateNotifications = () => {
  const queryClient = useQueryClient();

  const invalidateNotifications = (
    queries: "*" | NotificationsQuerySuffix[]
  ) => {
    if (queries === "*") {
      const queryKey: NotificationsQueryKey = ["notifications"];
      return queryClient.invalidateQueries({ queryKey });
    }

    queries.forEach((query) => {
      const queryKey: NotificationsQueryKey = ["notifications", query];
      queryClient.invalidateQueries({ queryKey });
    });
  };

  return {
    invalidateNotifications,
  };
};
